<ng-container
	*ngIf="{
		loading: loading | async,
		verifyEmail: verifyEmail | async,
		errorMessage: errorMessage | async,
	} as viewData"
>
	<div class="auth-container login">
		<sf-language-selector></sf-language-selector>
		<div class="card auth-content">
			<mat-progress-bar *ngIf="viewData.loading" mode="indeterminate"></mat-progress-bar>
			<div class="auth-content-inner">
				<img class="sf-logo" src="/assets/images/sf-logo.svg" alt="" />
				<ng-container *ngIf="!viewData.verifyEmail; else accountNotActivated">
					<h3 class="sf title">{{ 'sf.module.auth.log_in.title' | translate }}</h3>
					<form class="sign-in-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
						<span class="caption">{{ 'sf.module.auth.log_in.caption' | translate }}</span>
						<sf-error-box *ngIf="viewData.errorMessage" [label]="viewData.errorMessage"></sf-error-box>
						<div class="fields">
							<div class="field-wrapper">
								<sf-input
									#loginInput
									formControlName="email"
									[type]="'email'"
									[placeholder]="'sf.module.auth.log_in.log_in' | translate"
								>
								</sf-input>
							</div>
							<div class="field-wrapper">
								<sf-input-password
									formControlName="password"
									[showPasswordHint]="false"
									[placeholder]="'sf.module.auth.common.password' | translate"
								>
								</sf-input-password>
							</div>
						</div>

						<button
							class="login-button"
							type="submit"
							(keydown)="loginOnEnter($event)"
							mat-flat-button
							color="accent"
							[disabled]="loginForm.invalid || viewData.loading"
						>
							{{ 'sf.module.auth.log_in.title' | translate | uppercase }}
						</button>
						<div class="forgot-password-wrapper">
							<a class="link" [routerLink]="[RoutePath.AUTH, RoutePath.RESET_PASSWORD] | fullUrl">{{
								'sf.module.auth.log_in.reset_password' | translate
							}}</a>
						</div>

						<div class="separator"></div>
						<a class="create-account" [routerLink]="[RoutePath.AUTH, RoutePath.SIGN_UP] | fullUrl"
							><span>{{ 'sf.module.auth.log_in.create_account' | translate }}</span></a
						>
					</form>
				</ng-container>
				<ng-template #accountNotActivated>
					<sf-verify-email [usedEmail]="emailControl.value"></sf-verify-email>
					<div class="back-to-login-wrapper">
						<a class="link" (click)="backToLogin()">{{ 'sf.module.auth.common.back_to_login' | translate }}</a>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</ng-container>
